import Image from '@react/shared/components/Image';
import { RESOURCE_CENTER_PATH } from '@sly/core/constants/dashboardAppPaths';
import React from 'react';
import { assetPath } from 'sly/lib/path';
import { usePrefetch } from 'sly/services/api';
import {
  SitemapLayout,
  SitemapLink,
  SitemapLinkWrapper,
} from 'sly/sitemap/components/SitemapSharedComponents';
import { SITEMAP_RESOURCE_CENTER_BREADCRUMB_ITEMS } from 'sly/sitemap/constants';
import { Heading } from 'sly/system';

const ResourceCenterSitemap = () => {
  const {
    requestInfo: { result: topics, hasFinished: requestByTopicsHasFinished },
  } = usePrefetch('getTopic', { populate: ['articles'] });

  if (!requestByTopicsHasFinished) {
    return (
      <div
        className='flex h-screen items-center justify-center'
        data-tp-id='gen-div-4bb82603-e06c-4dfd-a287-dcba40106924'
      >
        <Image
          width='1'
          height='1'
          alt=''
          src={assetPath('uploads/react-assets/homebase/loader.svg')}
          data-tp-id='gen-Image-0e4c8021-b654-4283-bc56-9776dae7d9fb'
        />
      </div>
    );
  }

  return (
    <SitemapLayout
      headTitle='Resource Center Site Map | Seniorly'
      breadcrumbItems={SITEMAP_RESOURCE_CENTER_BREADCRUMB_ITEMS}
      metaDescription='Sitemap of all resource center pages on Seniorly. Find the resource center page you are looking for.'
    >
      <Heading
        as='h2'
        className='mb-6'
        data-tp-id='gen-Heading-e01889d1-1ff4-4ca1-94b4-3b399bfb0e7d'
      >
        Resource Center Links
      </Heading>

      <div
        className='mb-4'
        data-tp-id='gen-div-c2f369d6-e501-44fc-9379-69a53b4184ee'
      >
        <SitemapLink to={RESOURCE_CENTER_PATH} key='resource-center-home-page'>
          Resource Center Home Page
        </SitemapLink>
      </div>

      {topics?.data?.map(({ topicLink, name, articles }) => (
        <>
          <Heading as='h3' font='font-t-m' className='mb-6'>
            <SitemapLink to={`${topicLink}`} key={topicLink}>
              {name}
            </SitemapLink>
          </Heading>

          <SitemapLinkWrapper>
            {articles?.map(({ articleLink, title }) => (
              <SitemapLink to={articleLink} key={articleLink}>
                {title}
              </SitemapLink>
            ))}
          </SitemapLinkWrapper>
        </>
      ))}
    </SitemapLayout>
  );
};

export default ResourceCenterSitemap;
